import { render, staticRenderFns } from "./QuestionCategoryZLJ.vue?vue&type=template&id=809752f2&scoped=true"
import script from "./QuestionCategoryZLJ.vue?vue&type=script&lang=js"
export * from "./QuestionCategoryZLJ.vue?vue&type=script&lang=js"
import style0 from "./QuestionCategoryZLJ.vue?vue&type=style&index=0&id=809752f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "809752f2",
  null
  
)

export default component.exports